import * as Sentry from '@sentry/browser';

export const setTag = (key, value) => {
  Sentry.configureScope((scope) => {
    scope.setTag(key, value);
  });
};
